import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const FemaLimitExceededError: FunctionComponent = () => {
  return (
    <Fragment>
      <Text className="error-description">This transaction will result in a breach of your LRS limit of USD 250K pa</Text>
      <Text className="error-description">Please reduce the amount and try again. </Text>
    </Fragment>
  )
}

export default FemaLimitExceededError;
